"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEvent = exports.Event = void 0;

var pub_sub_1 = require("./pub-sub");
/**
 * New Event Classes.
 */


var Event =
/** @class */
function () {
  function Event(eventDescriptor) {
    this.value = null;
    this.publisher = new pub_sub_1.ConcretePublisher();
    this.isEventEmpty = true;
    if (eventDescriptor && eventDescriptor.initialValue) this.value = eventDescriptor.initialValue;
    this.reducer = eventDescriptor === null || eventDescriptor === void 0 ? void 0 : eventDescriptor.reducer;
  }

  Event.prototype.subscribe = function (subscriber, receiveLastValue) {
    if (receiveLastValue === void 0) {
      receiveLastValue = false;
    }

    var _subscriber = {
      update: subscriber
    };
    if (receiveLastValue) subscriber(this.get());
    return this.publisher.subscribe(_subscriber);
  };

  Event.prototype.dispatch = function (eventValue) {
    var value = Object.freeze(this.reducer !== null && this.reducer !== undefined ? this.reducer(eventValue) : eventValue);
    this.value = value;
    this.publisher.notify(value);
    this.isEventEmpty = false;
  };

  Event.prototype.get = function () {
    return Object.freeze(this.value);
  };

  Event.prototype.isEmpty = function () {
    return this.isEventEmpty;
  };
  /**
   * Removes all data from the Event store.
   *
   * @param {boolean} dispatch -
   */


  Event.prototype.clear = function (dispatch) {
    if (dispatch === void 0) {
      dispatch = false;
    }

    if (dispatch) {
      this.dispatch(null); // Empty dispatch
    } else {
      this.value = null;
    }

    this.isEventEmpty = true;
  };

  return Event;
}();

exports.Event = Event;
/**
 * Creates an event from a descriptor.
 *
 * @param {EventParams} eventDescriptor - Event options.
 * @returns {Event} - Event object.
 */

function createEvent(eventDescriptor) {
  return new Event(eventDescriptor);
}

exports.createEvent = createEvent;